<template>
    <div v-if="!session">
        <v-menu style="position:absolute;z-index:20">
          <v-btn class="btn_share"  slot="activator"  fab dark color="#007bff">
              <v-icon dark>fas fa-share-alt</v-icon>
          </v-btn>
            <social-sharing :url="url" 
              :title="title"
              :description="description"
              :quote="quote"
              inline-template>
              <v-list>
                <v-list-tile>
                  <network network="facebook" style="background:white;">
                    <label class="fab fa-facebook" style="font-size:20px;background:white;width:100%"> Facebook</label> 
                  </network>
                </v-list-tile>
                <v-list-tile style="margin-top:10px">
                  <br/>
                  <network network="twitter" style="background:white;">
                      <label class="fab fa-twitter" style="font-size:20px;background:white;"> Twitter</label> 
                  </network>
                </v-list-tile>
                <v-list-tile style="margin-top:10px">
                  <br/>
                  <network network="reddit" style="background:white">
                      <label class="fab fa-reddit" style="font-size:20px;background:white"> Reddit</label> 
                  </network>
                </v-list-tile>
                <v-list-tile style="margin-top:10px">
                  <br/>
                  <network network="googleplus" style="background:white">
                      <label class="fab fa-google" style="font-size:20px;background:white"> Google</label> 
                  </network>
                </v-list-tile>
                <v-list-tile style="margin-top:10px">
                  <br/>
                  <network network="whatsapp" style="background:white">
                      <label class="fab fa-whatsapp" style="font-size:20px;background:white"> Whatsapp</label> 
                  </network>
                </v-list-tile>
                <v-list-tile style="margin-top:10px">
                  <br/>
                  <network network="linkedin" style="background:white">
                      <label class="fab fa-linkedin" style="font-size:20px;background:white"> Linkedin</label> 
                  </network>
                </v-list-tile>
                <v-list-tile style="margin-top:10px">
                  <br/>
                  <network network="email" style="background:white">
                      <label class="fas fa-envelope" style="font-size:20px;background:white"> Email</label> 
                  </network>
                </v-list-tile>
                <v-list-tile style="margin-top:10px">
                  <br/>
                  <network network="telegram" style="background:white">
                      <label class="fab fa-telegram" style="font-size:20px;background:white"> Telegram</label> 
                  </network>
                </v-list-tile>
                <v-list-tile style="margin-top:10px">
                  <br/>
                  <network network="line" style="background:white">
                      <label class="fab fa-line" style="font-size:20px;background:white"> Line</label> 
                  </network>
                </v-list-tile>
                <v-list-tile style="margin-top:10px">
                  <br/>
                  <network network="pinterest" style="background:white">
                      <label class="fab fa-pinterest" style="font-size:20px;background:white"> Pinterest</label> 
                  </network>
                </v-list-tile>
                <v-list-tile style="margin-top:10px">
                  <br/>
                  <network network="sms" style="background:white">
                      <label class="fas fa-comment" style="font-size:20px;background:white"> SMS</label> 
                  </network>
                </v-list-tile>
                <v-list-tile style="margin-top:10px">
                  <br/>
                  <network network="skype" style="background:white">
                      <label class="fab fa-skype" style="font-size:20px;background:white"> Skype</label> 
                  </network>
                </v-list-tile>
              </v-list>	
            </social-sharing>			
        </v-menu>
        <div class="site-wrap">
        <main id="main">
            <v-dialog v-model="modaldescription" persistent max-width="290">
                <v-card>
                    <v-card-title class="headline">{{nameproject}}</v-card-title>
                    <v-card-text>{{descriptionproject}}</v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="modaldescription = false">{{language==='English'?'Close':'Cerrar'}}</v-btn>                    </v-card-actions>
                </v-card>
            </v-dialog>
            <div class="hero-section">
            <div class="container containerbeginning">
                <div>
                <div class="col-12 hero-text-image">
                    <div class="row">
                    <div class="col-lg-7 text-center text-lg-left">
                        <h1>{{language==='English'?'Publish your Projects in Amta':'Publica tus Proyectos en Amta'}}</h1>
                        <p class="mb-5">{{language==='English'?'and create your Professional Portfolio':'y crea tu Portafolio Profesional'}}</p>
                        <p><a @click="getstarted"
                            class="btn btn-outline-white">{{language==='English'?'Get started':'Comenzemos'}}</a></p>
                    </div>
                    <div class="col-lg-5 iphone-wrap hidden-xs-only hidden-sm-only">
                      <img src="/img/meeting-2284501_960_720.webp" alt="Image" class="phone-1">
                      <img src="/img/young-791849_960_720.webp" class="phone-2">
                    </div>
                    </div>
                </div>
                </div>
            </div>

            </div>

            <div class="site-section">
            <div class="container">
                
                <div class="row">
                <div class="col-md-4">
                    <div class="step">
                    <span class="number">01</span>
                    <h3>{{language==='English'?'Sign Up':'Registrate'}}</h3>
                    <p>{{language ==='English'?'Create your account in our platform':'Crea tu cuenta en nuestra plataforma.'}}</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="step">
                    <span class="number">02</span>
                    <h3>{{language==='English'?'Create Profile':'Crea tu Perfil'}}</h3>
                    <p>{{language==='English'?'The Platform will create your profile with your registered data.':'La Plataforma creará tu perfil con tus datos registrados.'}}</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="step">
                    <span class="number">03</span>
                    <h3>{{language==='English'?'Enjoy the app':'Disfruta la app'}}</h3>
                    <p>{{language==='English'?'Publish, Search, Comment your Projects and others.':'Publica, Busca, Comenta tus Proyectos y la de otros.'}}</p>
                    </div>
                </div>
                </div>
            </div>
            </div> <!-- .site-section -->
             <div class="text-center" style="margin-top:40px" v-if="bestprojects.length>0">
                <h1>{{language==='English'?'Projects':'Proyectos'}}</h1>
            </div>
            <section class="showcase" style="margin-bottom:40px" v-if="bestprojects.length>0">
              <v-layout justify-center style="margin-top:20px;">
                  <v-flex row lg9 xl8>
                      <v-card style="margin-top:20px"
                          v-for="(item, index) in bestprojects"
                          :key="index"
                          class="mx-auto"
                          max-width="320"
                      >
                          <v-img
                          :src="item.type==='Proyectos Electrónicos'?'/img/board-453758_640.jpg':
                          item.type==='Portafolio'?'/img/briefcase-161032_640.png':
                          item.type==='Ingenieria'?'/img/planning-3536758_640.jpg':
                          item.type==='General'?'/img/idea-1876659_640.jpg':''"
                          width="300px"
                          height="200px"
                          ></v-img>

                          <v-card-title>
                          {{item.name}}
                          </v-card-title>
                          <div class="w-100">
                              <v-img
                              style="margin-left:80%;cursor:pointer"
                              @click="goprofileuser(item._id_user.username)"
                              :src="item._id_user.photo[0].link"
                              width="40"
                              height="40"
                              ></v-img>
                          </div>

                          <v-card-actions>
                          <v-btn icon @click="checkfileproject(item._id)">
                  <v-icon>fas fa-eye</v-icon>
                </v-btn>
                          <v-btn icon @click="gocomments(item._id)">
                              <v-icon>fas fa-comments</v-icon>
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                              
                              @click="showdescription(item.name,item.description)"
                          >{{language==='English'?'See more':'Ver mas'}}

                          </v-btn>
                          </v-card-actions>
                      </v-card>
                  </v-flex>
              </v-layout>
          
      </section>


            <div class="site-section pb-0">
              <div class="container">
                  <div class="row align-items-center">
                    <div class="col-md-4 mr-auto">
                        <h2 class="mb-4">{{language === 'English'?'Share your projects':'Comparte tus proyectos'}}</h2>
                        <p class="mb-4">{{language === 'English'?'In Amta you can share your projects, creating your portfolio.':'En Amta podrás compartir tus proyectos, creando tu portafolio.'}}</p>
                    </div>
                    <div class="col-md-6" data-aos="fade-left">
                        <img src="/img/undraw_svg_2.svg" alt="Image" class="img-fluid">
                    </div>
                  </div>
              </div>
            </div> <!-- .site-section -->

            <div class="site-section">
              <div class="container">
                  <div class="row align-items-center">
                    <div class="col-md-4 ml-auto order-2">
                        <h2 class="mb-4">{{language === 'English'?'Share your work experiences':'Comparte tus experiencias laborales'}}</h2>
                        <p class="mb-4">{{language === 'English'?'In our platform you can disclose all your work experiences in your profile, so that they can contact you.':'En nuestra plataforma puedes divulgar todas tus experiencias laborales en tu perfil, para que así puedan contactarse contigo.'}}</p>
                    </div>
                    <div class="col-md-6">
                        <img src="/img/undraw_svg_3.svg" alt="Image" class="img-fluid">
                    </div>
                  </div>
              </div>
            </div> <!-- .site-section -->

            <div>
              <div class="container">
                  <div class="row align-items-center">
                    <div class="col-md-4 mr-auto">
                        <h2 class="mb-4">{{language === 'English'?'Receive feedback from your Projects':'Recibe feedback de tus Proyectos.'}}</h2>
                        <p class="mb-4">{{language === 'English'?'Receive feedback from other colleagues with your comments on each project you publish.':'Recibe feedback de parte de otros colegas tuyos con sus comentarios de cada proyecto que publique.'}}</p>
                    </div>
                    <div class="col-md-6" data-aos="fade-left">
                        <img src="/img/fax-1889009_640.jpg" alt="Image" class="img-fluid">
                    </div>
                  </div>
              </div>
            </div>
            <div>
              <div class="container">
                  <div class="row align-items-center">
                    <div class="col-md-4 ml-auto order-2">
                        <h2 class="mb-4">{{language === 'English'?'Use our Chat':'Utiliza nuestro Chat'}}</h2>
                        <p class="mb-4">{{language === 'English'?'Chat on our Chat service and communicate with other professionals, your followers and the people you are following.':'Chatea en nuestro servicio de Chat y comunicate con otros profesionales, tus seguidores y personas que estas siguiendo.'}}</p>
                    </div>
                    <div class="col-md-6" data-aos="fade-left">
                        <img src="/img/hello-4063591_640.png" alt="Image" class="img-fluid">
                    </div>
                  </div>
              </div>
            </div>
            <section class="showcase">
          <div class="container-fluid" style="margin-top:30px">
              <div class="text-center">
                  <h1>{{language==='English'?'Comments':'Comentarios'}}</h1>
                  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="validate">
                      <div class="row justify-center" style="padding-bottom:20px">
                          <div class="col-10 col-sm-8 col-md-9 col-lg-8">
                              <v-text-field v-model="commentscostumer.namecomplete" :rules="[rules.required]" :label="language === 'English'?'Name Complete':'Nombre Completo'"  
                              required>
                              </v-text-field>
                          </div>
                          <div class="col-10 col-sm-8 col-md-9 col-lg-8">
                              <v-text-field v-model="commentscostumer.email" :rules="[rules.required, rules.emailvalidate]" :label="language === 'English'?'Email':'Email'"  
                              required>
                              </v-text-field>
                          </div>
                          <div class="col-10 col-sm-8 col-md-9 col-lg-8">
                              <v-textarea v-model="commentscostumer.comments" :rules="[rules.required]" :label="language === 'English'?'Comments':'Comentarios'"  
                              required>
                              </v-textarea>
                          </div>
                          <div class="col-10 col-sm-8 col-md-9 col-lg-8">
                              <v-btn :disabled="!valid" color="#C7A7BE"  large style="border-radius:5px" type="submit">{{language === 'English'?'Send':'Enviar'}}</v-btn>
                          </div>
                          <br/>
                      </div>
                  </v-form>
              </div>
          </div>
      </section>


            <!--div class="site-section cta-section">
            <div class="container">
                <div class="row align-items-center">
                <div class="col-md-6 mr-auto text-center text-md-left mb-5 mb-md-0">
                    <h2>Starts Publishing Your Apps</h2>
                </div>
                <div class="col-md-5 text-center text-md-right">
                    <p><a href="#" class="btn"><span class="icofont-brand-apple mr-3"></span>App store</a> <a href="#"
                        class="btn"><span class="icofont-ui-play mr-3"></span>Google play</a></p>
                </div>
                </div>
            </div>
            </div-->


        </main>
        <footer class="footer" role="contentinfo">
            <div class="container">
            <div class="row">
                <div class="col-md-4 mb-4 mb-md-0">
                <h3>{{language=='English'?'About Future Sun':'Sobre Future Sun'}}</h3>
                <p>{{language==='English'?'We are a team that wants to develop Technology Projects for the world.':'Somos un equipo que queremos desarrollar Proyectos de Tecnología para el mundo.'}}</p>
                <p class="social" v-if="false">
                  <a href="https://www.facebook.com/hiproyect/" target="_blank"><span style="font-size:40px" class="fab fa-facebook"></span></a>
                  <a href="https://www.youtube.com/channel/UCrubuW5e0Y07cEKWnSe52JQ" target="_blank"><span style="font-size:40px" class="fab fa-youtube"></span></a>

                 
                    <!--a href="#"><span class="icofont-twitter"></span></a>
                    <a href="#"><span class="icofont-facebook"></span></a>
                    <a href="#"><span class="icofont-dribbble"></span></a>
                    <a href="#"><span class="icofont-behance"></span></a-->
                </p>
                </div>
                <div class="col-md-5 ml-auto">
                  <div class="row site-section pt-0">
                      <div class="col-md-6 mb-4 mb-md-0">
                      <h3>{{language==='English'?'Contact us':'Comunicate con nosotros'}}</h3>
                      <ul class="list-unstyled">
                          <li class="fab fa-whatsapp"><a style="margin-left:2px">+51954720526</a></li>
                          <br/>
                          <li class="fas fa-envelope"><a style="margin-left:2px">futuresuntec@gmail.com</a></li>
                      </ul>
                      </div>
                      <!--div class="col-md-4 mb-4 mb-md-0">
                      <h3>Services</h3>
                      <ul class="list-unstyled">
                          <li><a href="#">Team</a></li>
                          <li><a href="#">Collaboration</a></li>
                          <li><a href="#">Todos</a></li>
                          <li><a href="#">Events</a></li>
                      </ul>
                      </div>
                      <div class="col-md-4 mb-4 mb-md-0">
                      <h3>Downloads</h3>
                      <ul class="list-unstyled">
                          <li><a href="#">Get from the App Store</a></li>
                          <li><a href="#">Get from the Play Store</a></li>
                      </ul>
                      </div-->
                  </div>
                </div>
            </div>

            <div class="row justify-content-center text-center">
                <div class="col-md-7">
                <p class="copyright">&copy; Copyright Future Sun. All Rights Reserved</p>
                <!--div class="credits">
                   
                    Designed by <a href="https://bootstrapmade.com/">BootstrapMade</a>
                </div-->
                </div>
            </div>

            </div>
        </footer>
        </div> <!-- .site-wrap -->
        <!--v-layout justify-center>
            <v-dialog v-model="modaldescription" persistent max-width="290">
                <v-card>
                    <v-card-title class="headline">{{nameproject}}</v-card-title>
                    <v-card-text>{{descriptionproject}}</v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="modaldescription = false">{{language==='English'?'Close':'Cerrar'}}</v-btn>                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    <header class="masthead text-white text-center" style="margin-bottom:40px">
        <div class="overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-xl-9 mx-auto">
                <h1 class="mb-5" style="color:white">{{language === 'English'?'Welcome to Hi Proyect, look for a project that you are interested or a professional you want to know.':'Bienvenido a Hi Proyect, busca un Proyecto que este interesado o a algún profesional que desea conocer.'}}</h1>
                </div>
                <div class="col-md-10 col-lg-8 col-xl-7 mx-auto">
                    <button class="btn btn-primary" style="margin-bottom:30px" type="submit" @click="opentutorial">{{language==='English'?'Let`s see the tutorial':'Veamos el tutorial'}}</button>
                <div>
                    <div class="form-row">
                    <div class="col-12 col-md-12 mb-2 mb-md-0">
                        <div class="J-chat-form">
                            <input class="form-control J-chat-input" @keyup.enter="gosearchproject" v-model="searchproject" :placeholder="language === 'English'?'Enter the Project Name':'Ingrese el Nombre del Proyecto'"/>
                            <button class="btn J-chat-btn" type="submit" @click="gosearchproject">{{language==='English'?'Search':'Buscar'}}</button>
                        </div>
                    </div>
                    <div class="col-12 col-md-12 mb-2 mb-md-0">
                        <div class="autocomplete">
                            <input  @keyup="openlistsearch" v-model="textsearch" :placeholder="language === 'English'?'Enter the Name of the Professional or Amateur':'Ingrese el Nombre del Profesional o Aficionado'" class="form-control J-search-map w-100">
                            <ul class="autocomplete-results" v-click-outside="closelistsearchusers"  v-if="listsearchopened">
                                <li class="loading" v-if="isLoading">
                                    Loading results...
                                </li>
                                <li class="autocomplete-result" v-else v-for="arrayfindedusers in arrayfindedusers" :key="arrayfindedusers.length" @click="goprofileuser(arrayfindedusers.username)">
                                    <v-list-tile>
                                        <v-list-tile-avatar>
                                            <img :src="arrayfindedusers.photo[0].link">
                                        </v-list-tile-avatar>
                                        <v-list-tile-content>
                                            <v-list-tile-title style="font-size: 15px; font-weight: bold">{{arrayfindedusers.fullname}}</v-list-tile-title>
                                            <v-divider></v-divider>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </li>
                            </ul>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </header>
    <div class="text-center" style="margin-top:40px" v-if="bestprojects.length>0">
        <h1>{{language==='English'?'Projects':'Proyectos'}}</h1>
    </div>
    <section class="showcase" style="margin-bottom:40px" v-if="bestprojects.length>0">
            <v-layout justify-center style="margin-top:20px;">
                <v-flex row lg9 xl8>
                    <v-card style="margin-top:20px"
                        v-for="(item, index) in bestprojects"
                        :key="index"
                        class="mx-auto"
                        max-width="300"
                    >
                        <v-img
                        :src="item.type==='Proyectos Electrónicos'?'/img/board-453758_640.jpg':
                        item.type==='Portafolio'?'/img/briefcase-161032_640.png':
                        item.type==='Ingenieria'?'/img/planning-3536758_640.jpg':
                        item.type==='General'?'/img/idea-1876659_640.jpg':''"
                        width="300px"
                        height="200px"
                        ></v-img>

                        <v-card-title>
                        {{item.name}}
                        </v-card-title>
                        <div class="w-100">
                            <v-img
                            style="margin-left:80%;cursor:pointer"
                            @click="goprofileuser(item._id_user.username)"
                            :src="item._id_user.photo[0].link"
                            width="40"
                            height="40"
                            ></v-img>
                        </div>

                        <v-card-actions>
                        <v-btn icon @click="checkfileproject(item._id)">
								<v-icon>fas fa-eye</v-icon>
							</v-btn>
                        <v-btn icon @click="gocomments(item._id)">
                            <v-icon>fas fa-comments</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            
                            @click="showdescription(item.name,item.description)"
                        >{{language==='English'?'See more':'Ver mas'}}

                        </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        
    </section>
    <section class="showcase">
        <div class="container-fluid" style="margin-top:30px">
            <div class="text-center">
                <h1>{{language==='English'?'Comments':'Comentarios'}}</h1>
                <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="validate">
                    <div class="row justify-center" style="padding-bottom:20px">
                        <div class="col-10 col-sm-8 col-md-9 col-lg-7">
                            <v-text-field v-model="commentscostumer.namecomplete" :rules="[rules.required]" :label="language === 'English'?'Name Complete':'Nombre Completo'"  
                            required>
                            </v-text-field>
                        </div>
                        <div class="col-10 col-sm-8 col-md-9 col-lg-7">
                            <v-text-field v-model="commentscostumer.email" :rules="[rules.required, rules.emailvalidate]" :label="language === 'English'?'Email':'Email'"  
                            required>
                            </v-text-field>
                        </div>
                        <div class="col-10 col-sm-8 col-md-9 col-lg-7">
                            <v-textarea v-model="commentscostumer.comments" :rules="[rules.required]" :label="language === 'English'?'Comments':'Comentarios'"  
                            required>
                            </v-textarea>
                        </div>
                        <div class="col-10 col-sm-8 col-md-9 col-lg-7">
                            <v-btn :disabled="!valid" color="#C7A7BE"  large style="border-radius:5px" type="submit">{{language === 'English'?'Send':'Enviar'}}</v-btn>
                        </div>
                        <br/>
                    </div>
                </v-form>
            </div>
        </div>
    </section>

        <div class="container">
        <div class="row">
            <div class="col-lg-4">
            <div class="features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3">
                <div class="features-icons-icon d-flex">
                <i class="icon-screen-desktop m-auto text-primary"></i>
                </div>
                <h3>Fully Responsive</h3>
                <p class="lead mb-0">This theme will look great on any device, no matter the size!</p>
            </div>
            </div>
            <div class="col-lg-4">
            <div class="features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3">
                <div class="features-icons-icon d-flex">
                <i class="icon-layers m-auto text-primary"></i>
                </div>
                <h3>Bootstrap 4 Ready</h3>
                <p class="lead mb-0">Featuring the latest build of the new Bootstrap 4 framework!</p>
            </div>
            </div>
            <div class="col-lg-4">
            <div class="features-icons-item mx-auto mb-0 mb-lg-3">
                <div class="features-icons-icon d-flex">
                <i class="icon-check m-auto text-primary"></i>
                </div>
                <h3>Easy to Use</h3>
                <p class="lead mb-0">Ready to use with your own content, or customize the source files!</p>
            </div>
            </div>
        </div>
        </div>
    <section class="showcase">
        <div class="container-fluid p-0">
        <div class="row no-gutters">

            <div class="col-lg-6 order-lg-2 text-white showcase-img" style="background-image: url('img/meeting-2284501_960_720.webp');"></div>
            <div class="col-lg-6 order-lg-1 my-auto showcase-text">
            <h2>{{language === 'English'?'Share your projects':'Comparte tus proyectos'}}</h2>
            <p class="lead mb-0">{{language === 'English'?'In Hiproyect you can share your projects, creating your portfolio.':'En Hiproyect podrás compartir tus proyectos, creando tu portafolio.'}}
            </p>
            </div>
        </div>
        <div class="row no-gutters">
            <div class="col-lg-6 text-white showcase-img" style="background-image: url('img/young-791849_960_720.webp');"></div>
            <div class="col-lg-6 my-auto showcase-text">
            <h2>{{language === 'English'?'Share your work experiences':'Comparte tus experiencias laborales'}}</h2>
            <p class="lead mb-0">{{language === 'English'?'In our platform you can disclose all your work experiences in your profile, so that they can contact you.':'En nuestra plataforma puedes divulgar todas tus experiencias laborales en tu perfil, para que así puedan contactarse contigo.'}}</p>
            </div>
        </div>
        <div class="row no-gutters">
            <div class="col-lg-6 order-lg-2 text-white showcase-img" style="background-image: url('img/feedback-1825515_960_720.webp');"></div>
            <div class="col-lg-6 order-lg-1 my-auto showcase-text">
            <h2>{{language === 'English'?'Receive feedback from your Projects':'Recibe feedback de tus Proyectos.'}}</h2>
            <p class="lead mb-0">{{language === 'English'?'Receive feedback from other colleagues with your comments on each project you publish.':'Recibe feedback de parte de otros colegas tuyos con sus comentarios de cada proyecto que publique.'}}</p>
            </div>
        </div>
        </div>
    </section>

        <h2 class="mb-5">Fundadores</h2>
        <div>
            <div class="col-12">
                <h5>Kenneth Brandon Dueñas Contreras: Co-fundador, Presidente y CEO.</h5>
            </div>
            <div class="col-12">
                <h5>Diana Carolina Ch. Jauregui: Co-fundadora, Board Member</h5>
            </div>
            <div class="col-lg-4">
            <div class="testimonial-item mx-auto mb-5 mb-lg-0">
                <img class="img-fluid rounded-circle mb-3" src="img/32853576_1374603682684734_5409716698943062016_n.jpg" alt="">
                 <h5>Kenneth Brandon Dueñas Contreras</h5>
                <p class="font-weight-light mb-0">Co-fundador y Presidente</p>
            </div>
            </div-->
            <!--div class="col-lg-4">
            <div class="testimonial-item mx-auto mb-5 mb-lg-0">
                <img class="img-fluid rounded-circle mb-3" src="img/testimonials-2.jpg" alt="">
                <h5>Diana Carolina CH Jauregui</h5>
                <p class="font-weight-light mb-0">Co-fundadora y CEO</p>
            </div>
            </div>
            <div class="col-lg-4">
            <div class="testimonial-item mx-auto mb-5 mb-lg-0">
                <img class="img-fluid rounded-circle mb-3" src="img/testimonials-3.jpg" alt="">
                <h5>Joshua Antonio Villaverde Villanueva</h5>
                <p class="font-weight-light mb-0">Co-fundador y Vicepresidente</p>
            </div>
            </div>
        </div>
    <div class="fondo1" style="padding: 50px;">
        <p style="text-align:center;">@ HiProyect SAC. 2020</p>
    </div-->
    </div>
</template>
<script>
const alertify = require('alertifyjs')
// Import the EventBus we just created.
import { EventBus } from '../../../../helpers/eventbus/event-bus.js'
import env from './../../../../config/env.example'


//Componentes


import initVue from '../../../../helpers/initVue'

import Commentscostumer from '../../../../models/commentscostumer'

import { CommentsuserService, ProjectService, UsersService } from "@/services"





import {
  mapGetters
} from 'vuex'

export default {
    data () { 
      return { 
        commentscostumer:new Commentscostumer(),
        searchproject:'',
        description: '',
        quote:'',
        title:'',
        url:window.location.href,
        valid:true, 
        dialog3:false,
        dialog4: false,
        identity: null,
        session: false,
        seedescription:false,
        token: null,
        userstorage: {},
        bestprojects:[],
        imageName: '',
        language: JSON.parse(localStorage.getItem('language')) !== null ? JSON.parse(localStorage.getItem('language')).language : '',
        imageUrl: '',
        imageFile: '',
        addressempty: false,
        arrayfindedusers: [],
        listsearchopened:false,
        nameproject: '',
        descriptionproject:'',
        modaldescription: false,
        textsearch : '',
        rules: {
            required: value => !!value || `${this.language === 'English'?'Required':'Requerido.'}`,
            emailvalidate: value =>{
             const pattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
             return pattern.test(value) || `${this.language === 'English'? 'the email must contain @ and others characters': 'El email debe contener @ y otros carácteres mas'}`
           },
        }
      }
    },

    computed: mapGetters({
        indetityU: 'getIdentity',
        tokenU: 'getToken'
    }),
    mounted(){
        this.description = this.language==='English'?'Publish your projects in Amta and create your professional portfolio.':'Publica tus proyectos en Amta y crea tu portafolio profesional.'
				this.title = this.language==='English'?'Publish your projects in Amta and create your professional portfolio.':'Publica tus proyectos en Amta y crea tu portafolio profesional.'
				this.quote = this.language==='English'?'Publish your projects in Amta and create your professional portfolio.':'Publica tus proyectos en Amta y crea tu portafolio profesional.'
        this.getidentity()
        this.getuser()
        this.getfiveprojects()
        EventBus.$on('changelanguage',()=>{
            let choosedlanguage = JSON.parse(localStorage.getItem('language'))
            this.language = choosedlanguage.language
            //console.log(this.language)
            //console.log(choosedlanguage)
        })
        let choosedlanguage = JSON.parse(localStorage.getItem('language'))
        if(choosedlanguage){
            this.language = choosedlanguage.language
        }
        //console.log(this.$route.params.id)
        /*
        if(!this.session){
            axios.get(`${config.serverweb}getid`)
            .then((res) =>{
                let iduser = res.data.iduser
                axios.get(`${config.serverweb}localstorage/${iduser}`)
                .then((res)=>{
                    this.identity = res.data.userdata.user
                    this.token = res.data.userdata.token
                    console.log(this.identity)
                    //console.log(this.token)

                  
                    setTimeout(() => {
                        this.saveIdentity()
                        window.location = '/'
                    }, 400)
                })
                .catch((err) => {
                    console.log(err)
                })
            })
            .catch((err) => {
                console.log(err)
            })
        }

        */

        //new user
        //console.log(this.identity)



    },
    sockets:{
        getpunctuation(data){
			let statevote = data
			if(statevote){
				if(statevote.ok){
					this.getfiveprojects()
				}
			}
		}
    },
    methods: {
        getstarted(){
          EventBus.$emit('opentutorialwrited')
        },
        goprofileuser(username){
            window.location = `${env.host}${username}`
        },
        gocomments(idproject){
            this.$router.push('/comments/'+idproject)
        },
        checkfileproject(idproject){
            this.$router.push('/projects/'+idproject)
        },
        showdescription(name,description){
            this.nameproject = name
            this.descriptionproject = description
            this.modaldescription = true
            
        },
        async getfiveprojects(){
            try{
                let dataindex ={

                }
                const res = await ProjectService.getfiveprojectindex(dataindex)
                let { status, data } = res
                if(status===200){
                    this.bestprojects = data.projectorder
                }
            }catch(err){
                console.log(err)
            }
        },
        validate() {
            if (this.$refs.form.validate()) {
                this.snackbar = true
                CommentsuserService.sendcommentscostumer(this.commentscostumer).then(res=>{
                    this.commentscostumer = new Commentscostumer()
                    alertify.success(this.language==="English"?'Comment sended':'Comentario enviado')
                })
            }
        },
        opentutorial(){
            EventBus.$emit('opentutorial')
        },
        gosearchproject(){
            let wordssearchprojectisempty = this.searchproject === ''
            if(!wordssearchprojectisempty){
             window.location = `${env.host}searchproject/${this.searchproject}`
            }
        },

 /* * Obteniendo la identidad para validar el token
 *******************************************************/
        getidentity(){
            this.identity = initVue.getIdentity().identity
            this.token = initVue.getIdentity().token
            this.session = initVue.isLogged(this.identity, this.token)
            //console.log(this.session)
        },

        /****************** * Guardar datos para identificar si el usuarios ha iniciado sesión ***************************************************+*/
        opendialog3(){
          this.dialog3=true
        },

        opendialog4(){
          this.dialog4 = true
          this.dialog3 = false
        },

        closedialog4(){
            this.dialog4 = false
        },

         openmodalWhatdowedo(){
            EventBus.$emit('openmodalWhatdowedo')
        },
        goprofileuser(username){
            this.listsearchopened = false
            window.location = `${env.host}${username}`
            /*
            this.$router.push({
                name: 'Profileuser',
                params: { nameuser: username}
            })
            EventBus.$emit('getdatauserwithvalidation')*/
        },
        getuser(){
            if(this.session){
              let query = {
              }
              UsersService.getdatauser(query).then(res=>{
                 this.userstorage = res.data.user
              })
            }
        },

        pickFile () {
            this.$refs.image.click()
        },
        openlistsearch(){
            let textempty = this.textsearch === ''
            if(textempty){
                this.listsearchopened = false
            }else{
                this.axios.get(`users/searchusers/${this.textsearch}`)
                /******************* * Login Exitoso!!!!******************************* */
                .then(res => {
                  //console.log(res.data.company)
                  this.arrayfindedusers = res.data.users
                  this.listsearchopened = true
                  //console.log(this.arrayfindedusers)
                
                })
                /******************* * Login Errado!!!!********************************/
                .catch(() => {
                  this.listsearchopened = false
                })
            }
        },

        onFilePicked (e) {
			const files = e.target.files
			if(files[0] !== undefined) {
				this.imageName = files[0].name
				if(this.imageName.lastIndexOf('.') <= 0) {
					return
                }
                
                if (!(/\.(jpg|png|gif)$/i).test(this.imageName))
                {
                    alert('Comprueba la extensión de tus imagenes, recuerda que los formatos aceptados son .gif, .jpeg, .jpg y .png');
                    this.imageName = ''
                    this.imageUrl = this.userstorage.photo
                }else{
                    const fr = new FileReader ()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.imageUrl = fr.result
                        this.imageFile = files[0] // this is an image file that can be sent to server...
                        this.imageName = files[0].name
                        //console.log(this.imageUrl)


                    })
                }
			} else {
				this.imageName = ''
				this.imageFile = ''
				this.imageUrl = this.userstorage.photo
			}
        },

        editdatanewuser(){
            if (this.$refs.form.validate()) {
                this.snackbar = true
                this.users.imageFile = this.imageUrl
                this.axios.put(`users/editnewuser/${this.identity._id}/${this.token}`, this.users)
                .then((res) =>{
                    this.getuser()
                    EventBus.$emit('getuser')
                    this.closedialog4()
                })

                .catch((err) =>{
                    this.getuser()
                    EventBus.$emit('getuser')
                    console.log(err)

                })
            }

        }, 



    }

}

</script>
<style lang="scss" scoped>
.btn_share{
   position: fixed;
    width: 44px;
    height: 44px;
    text-align: center;
    line-height: 2;
    font-size: 16px;
    border-radius: 50%;
    left: 15px;
    bottom: 15px;
    font-size:22px;
    z-index: 10;
}
.containerbeginning{
  padding-top:90px
}
.font-heading {
  font-family: "Poppins", sans-serif;
  color: #000;
}
@media only screen and (min-width: 992px) {
  .containerbeginning{
    padding-top:250px
  }
}


.container {
  z-index: 2;
  position: relative;
}

.text-black {
  color: #000 !important;
}

.text-primary {
  color: #2d71a1 !important;
}

.border-top {
  border-top: 1px solid #f2f2f2 !important;
}

.border-bottom {
  border-bottom: 1px solid #f2f2f2 !important;
}

figure figcaption {
  margin-top: .5rem;
  font-style: italic;
  font-size: .8rem;
}

.site-section {
  padding: 7rem 0;
}

.section-heading {
  font-size: 3rem;
  font-weight: 700;
  background: linear-gradient(-45deg, #3db3c5, #274685);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* Back to top button */

.back-to-top {
  position: fixed;
  display: none;
  background: #2d71a1;
  color: #fff;
  width: 44px;
  height: 44px;
  text-align: center;
  line-height: 1;
  font-size: 16px;
  border-radius: 50%;
  right: 15px;
  bottom: 15px;
  transition: background 0.5s;
  z-index: 11;
}

.back-to-top i {
  color: #fff;
  font-size: 24px;
  position: absolute;
  top: 8px;
  left: 10px;
}

/* Default btn sre-tyling */

.btn {
  border: none;
  padding: 15px 30px !important;
}

.btn.btn-outline-white {
  border: 2px solid #fff;
  background: none;
  color: #fff;
}

.btn.btn-outline-white:hover {
  background: #fff;
  color: #2d71a1;
}

.btn.btn-primary {
  background: #2d71a1;
  background: linear-gradient(-45deg, #1391a5, #274685);
  color: #fff;
  box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.15);
}

/* Feature 1 */

.feature-1 .wrap-icon {
  margin: 0 auto;
  height: 100px;
  width: 100px;
  border-radius: 50%;
  position: relative;
  margin-bottom: 30px;
  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.2);
}

.feature-1 .wrap-icon.icon-1 {
  background: linear-gradient(-45deg, #3b87bd, #2d71a2);
}

.feature-1 .wrap-icon .icon {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 2.5rem;
}

.feature-1 h3 {
  font-size: 20px;
}

.feature-1 p {
  color: #b1b1b1;
}

/* Step */

.step {
  box-shadow: 0 10px 30px -5px rgba(0, 0, 0, 0.1);
  background: #fff;
  padding: 40px;
}

.step .number {
  background: linear-gradient(-45deg, #1391a5, #274685);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 700;
  letter-spacing: .2rem;
  margin-bottom: 10px;
  display: block;
}

.step p:last-child {
  margin-bottom: 0px;
}

/* Review */

.review h3 {
  font-size: 20px;
}

.review p {
  line-height: 1.8;
  font-style: italic;
  color: #333333;
}

.review .stars span {
  color: #FF8803;
}

.review .stars .muted {
  color: #ccc;
}

.review .review-user img {
  width: 70px;
  margin: 0 auto;
}

/* Testimonial Carousel */

.testimonial-carousel .owl-dots {
  position: absolute;
  bottom: -40px;
  width: 100%;
  text-align: center;
}

.testimonial-carousel .owl-dots .owl-dot {
  display: inline-block;
}

.testimonial-carousel .owl-dots .owl-dot > span {
  display: inline-block;
  width: 7px;
  height: 7px;
  background-color: #cbd3da;
  border-radius: 50%;
  margin: 5px;
}

.testimonial-carousel .owl-dots .owl-dot.active {
  outline: none;
}

.testimonial-carousel .owl-dots .owl-dot.active > span {
  background: linear-gradient(-45deg, #1391a5, #274685);
}

/* Pricing */

.pricing {
  padding: 50px;
  background: linear-gradient(-45deg, #1391a5, #274685);
  color: #fff;
  padding-bottom: 12rem !important;
  position: relative;
  border-radius: 4px;
  color: #000000;
  background: #fff;
  box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.2);
}

.pricing h3 {
  color: #2d71a1;
}

.pricing .price-cta {
  position: absolute;
  bottom: 50px;
  width: 100%;
  text-align: center;
  left: 0;
}

.pricing .price-cta .price {
  display: block;
  margin-bottom: 20px;
  font-size: 2rem;
  font-weight: 300;
}

.pricing .popularity {
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: .2rem;
  display: block;
  margin-bottom: 20px;
}

.pricing ul {
  margin-bottom: 50px;
}

.pricing ul li {
  margin-bottom: 10px;
}

.pricing .btn-white {
  background: #fff;
  border: 2px solid #f1f1f1;
  border-radius: 4px;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);
}

.pricing .btn-white:hover {
  color: #2d71a1;
}

.pricing.popular {
  background: #fff;
  box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.2);
  color: #000000;
  background: linear-gradient(-45deg, #1391a5, #274685);
  color: #fff;
  box-shadow: none;
}

.pricing.popular .popularity {
  color: #b3b3b3;
}

.pricing.popular h3 {
  color: #fff;
  background: none;
}

.pricing.popular .btn-white {
  border: 2px solid #2d71a1;
}

/* CTA Section */

.cta-section {
  background: linear-gradient(to right, #274685 0%, #3db3c5 100%);
  color: #fff;
}

.cta-section h2 {
  color: #fff;
  font-size: 3rem;
  font-weight: 700;
}

.cta-section .btn {
  background: #000000;
  color: #fff;
}

/* Sticky Wrapper */

.sticky-wrapper {
  position: absolute;
  z-index: 100;
  width: 100%;
}

.sticky-wrapper .site-navbar {
  transition: .3s all ease;
}

.sticky-wrapper .site-navbar .site-menu-toggle {
  color: #fff;
}

.sticky-wrapper .site-navbar .site-logo a {
  color: #fff;
}

.sticky-wrapper .site-navbar .site-menu > li > a {
  color: rgba(255, 255, 255, 0.8) !important;
}

.sticky-wrapper .site-navbar .site-menu > li > a:hover,
.sticky-wrapper .site-navbar .site-menu > li > a.active {
  color: #fff !important;
}

.sticky-wrapper.is-sticky .burger:before,
.sticky-wrapper.is-sticky .burger span,
.sticky-wrapper.is-sticky .burger:after {
  background: #000000;
  transition: .0s all ease;
}

.sticky-wrapper.is-sticky .site-navbar {
  background: #fff;
  border-bottom: 1px solid transparent;
  box-shadow: 4px 0 20px -5px rgba(0, 0, 0, 0.2);
}

.sticky-wrapper.is-sticky .site-navbar .site-logo a {
  color: #000000 !important;
}

.sticky-wrapper.is-sticky .site-navbar .site-menu > li > a {
  color: #000000 !important;
}

.sticky-wrapper.is-sticky .site-navbar .site-menu > li > a:hover,
.sticky-wrapper.is-sticky .site-navbar .site-menu > li > a.active {
  color: #2d71a1 !important;
}

.sticky-wrapper.is-sticky .site-navbar .site-menu > li.active a {
  color: #2d71a1 !important;
}

.sticky-wrapper .shrink {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

/* Contact Form */

.form-control {
  height: 53px;
  border-radius: 0;
  border: 1px solid #dae0e5;
}

.form-control:active,
.form-control:focus {
  outline: none;
  box-shadow: none;
  border: 1px solid #2d71a1;
}

.php-email-form .validate {
  display: none;
  color: red;
  margin: 0 0 15px 0;
  font-weight: 400;
  font-size: 13px;
}

.php-email-form .error-message {
  display: none;
  color: #fff;
  background: #ed3c0d;
  text-align: center;
  padding: 15px;
  font-weight: 600;
}

.php-email-form .sent-message {
  display: none;
  color: #fff;
  background: #18d26e;
  text-align: center;
  padding: 15px;
  font-weight: 600;
}

.php-email-form .loading {
  display: none;
  background: #fff;
  text-align: center;
  padding: 15px;
}

.php-email-form .loading:before {
  content: "";
  display: inline-block;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  margin: 0 10px -6px 0;
  border: 3px solid #18d26e;
  border-top-color: #eee;
  -webkit-animation: animate-loading 1s linear infinite;
  animation: animate-loading 1s linear infinite;
}

@-webkit-keyframes animate-loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes animate-loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

/* Blog */

.post-entry {
  margin-bottom: 60px;
}

.post-entry .post-text .post-meta {
  color: #ccc;
  font-size: 13px;
  display: block;
  margin-bottom: 10px;
}

.post-entry .post-text h3 {
  font-size: 20px;
  color: #000000;
}

.post-entry .post-text h3 a {
  color: #000000;
}

.post-entry .post-text h3 a:hover {
  text-decoration: none;
  color: #2d71a1;
}

.post-entry .post-text .readmore {
  color: #2d71a1;
}

.sidebar-box {
  margin-bottom: 30px;
  padding: 25px;
  font-size: 15px;
  width: 100%;
  float: left;
  background: #fff;
}

.sidebar-box *:last-child {
  margin-bottom: 0;
}

.sidebar-box h3 {
  font-size: 18px;
  margin-bottom: 15px;
}

.categories li,
.sidelink li {
  position: relative;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px dotted gray("300");
  list-style: none;
}

.categories li:last-child,
.sidelink li:last-child {
  margin-bottom: 0;
  border-bottom: none;
  padding-bottom: 0;
}

.categories li a,
.sidelink li a {
  display: block;
}

.categories li a span,
.sidelink li a span {
  position: absolute;
  right: 0;
  top: 0;
  color: #ccc;
}

.categories li.active a,
.sidelink li.active a {
  color: #000000;
  font-style: italic;
}

.comment-form-wrap {
  clear: both;
}

.comment-list {
  padding: 0;
  margin: 0;
}

.comment-list .children {
  padding: 50px 0 0 40px;
  margin: 0;
  float: left;
  width: 100%;
}

.comment-list li {
  padding: 0;
  margin: 0 0 30px 0;
  float: left;
  width: 100%;
  clear: both;
  list-style: none;
}

.comment-list li .vcard {
  width: 80px;
  float: left;
}

.comment-list li .vcard img {
  width: 50px;
  border-radius: 50%;
}

.comment-list li .comment-body {
  float: right;
  width: calc(100% - 80px);
}

.comment-list li .comment-body h3 {
  font-size: 20px;
}

.comment-list li .comment-body .meta {
  text-transform: uppercase;
  font-size: 13px;
  letter-spacing: .1em;
  color: #ccc;
}

.comment-list li .comment-body .reply {
  padding: 5px 10px;
  background: #e6e6e6;
  color: #000000;
  text-transform: uppercase;
  font-size: 14px;
}

.comment-list li .comment-body .reply:hover {
  color: #000000;
  background: #e3e3e3;
}

.search-form {
  background: #f7f7f7;
  padding: 10px;
}

.search-form .form-group {
  position: relative;
}

.search-form .form-group input {
  padding-right: 50px;
}

.search-form .icon {
  position: absolute;
  top: 50%;
  right: 20px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}

/*--------------------------------------------------------------
# Header Section
--------------------------------------------------------------*/

.hero-section {
  background: linear-gradient(to right, rgba(39, 70, 133, 0.8) 0%, rgba(61, 179, 197, 0.8) 100%), url('/img/hero-bg.jpg');
  position: relative;
}

.hero-section .wave {
  width: 100%;
  overflow: hidden;
  position: absolute;
  z-index: 1;
  bottom: -150px;
}

.hero-section .wave svg {
  width: 100%;
}

.hero-section,
.hero-section > .container > .row {
  height: 100vh;
  min-height: 880px;
}

.hero-section.inner-page {
  height: 60vh;
  min-height: 0;
}

.hero-section.inner-page .hero-text {
  -webkit-transform: translateY(-150px);
  transform: translateY(-150px);
  margin-top: -120px;
}

.hero-section h1 {
  font-size: 3.5rem;
  color: #fff;
  font-weight: 700;
  margin-bottom: 30px;
}

.hero-section p {
  font-size: 18px;
  color: #fff;
}

.hero-section .iphone-wrap {
  position: relative;
  margin-top:80px
}

.hero-section .iphone-wrap .phone-2,
.hero-section .iphone-wrap .phone-1 {
  position: absolute;
  top: -50%;
  overflow: hidden;
  left: 0;
  box-shadow: 0 15px 50px 0 rgba(0, 0, 0, 0.3);
  border-radius: 30px;
}

.hero-section .iphone-wrap .phone-2,
.hero-section .iphone-wrap .phone-1 {
  width: 400px;
}

.hero-section .iphone-wrap .phone-2 {
  margin-top: 50px;
  margin-left: 100px;
  width: 300px;
}

/*--------------------------------------------------------------
# Nav
--------------------------------------------------------------*/

.site-navbar {
  margin-bottom: 0px;
  z-index: 1999;
  position: absolute;
  top: 0;
  width: 100%;
}

.site-navbar .site-logo {
  position: relative;
  font-size: 24px;
}

.site-navbar .site-logo a {
  color: #fff;
}

.site-navbar .site-logo a:hover {
  text-decoration: none;
}

.site-navbar .site-navigation .site-menu {
  margin-bottom: 0;
}

.site-navbar .site-navigation .site-menu a {
  text-decoration: none !important;
  display: inline-block;
}

.site-navbar .site-navigation .site-menu > li {
  display: inline-block;
}

.site-navbar .site-navigation .site-menu > li > a {
  padding: 30px 20px;
  color: #000000;
  display: inline-block;
  text-decoration: none !important;
}

.site-navbar .site-navigation .site-menu > li > a:hover {
  color: #2d71a1;
}

.site-navbar .site-navigation .site-menu > li.active > a {
  color: #fff !important;
}

.site-navbar .site-navigation .site-menu .has-children {
  position: relative;
}

.site-navbar .site-navigation .site-menu .has-children > a {
  position: relative;
  padding-right: 20px;
}

.site-navbar .site-navigation .site-menu .has-children > a:before {
  position: absolute;
  content: "\ea99";
  font-size: 16px;
  top: 52%;
  right: 0;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  font-family: 'icofont';
}

.site-navbar .site-navigation .site-menu .has-children .dropdown {
  visibility: hidden;
  opacity: 0;
  top: 100%;
  position: absolute;
  text-align: left;
  box-shadow: 0 2px 10px -2px rgba(0, 0, 0, 0.1);
  padding: 0px 0;
  margin-top: 15px;
  margin-left: 0px;
  background: #fff;
  transition: 0.2s 0s;
}

.site-navbar .site-navigation .site-menu .has-children .dropdown.arrow-top {
  position: absolute;
}

.site-navbar .site-navigation .site-menu .has-children .dropdown.arrow-top:before {
  bottom: 100%;
  left: 20%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.site-navbar .site-navigation .site-menu .has-children .dropdown.arrow-top:before {
  border-color: rgba(136, 183, 213, 0);
  border-bottom-color: #fff;
  border-width: 10px;
  margin-left: -10px;
}

.site-navbar .site-navigation .site-menu .has-children .dropdown a {
  text-transform: none;
  letter-spacing: normal;
  transition: 0s all;
  color: #000000;
}

.site-navbar .site-navigation .site-menu .has-children .dropdown .active {
  color: #2d71a1 !important;
}

.site-navbar .site-navigation .site-menu .has-children .dropdown > li {
  list-style: none;
  padding: 0;
  margin: 0;
  min-width: 210px;
}

.site-navbar .site-navigation .site-menu .has-children .dropdown > li > a {
  padding: 9px 20px;
  display: block;
}

.site-navbar .site-navigation .site-menu .has-children .dropdown > li > a:hover {
  background: #f2f4f6;
  color: #000000;
}

.site-navbar .site-navigation .site-menu .has-children .dropdown > li.has-children > a:before {
  content: "\ea75";
  right: 20px;
}

.site-navbar .site-navigation .site-menu .has-children .dropdown > li.has-children > .dropdown,
.site-navbar .site-navigation .site-menu .has-children .dropdown > li.has-children > ul {
  left: 100%;
  top: 0;
}

.site-navbar .site-navigation .site-menu .has-children .dropdown > li.has-children:hover > a,
.site-navbar .site-navigation .site-menu .has-children .dropdown > li.has-children:active > a,
.site-navbar .site-navigation .site-menu .has-children .dropdown > li.has-children:focus > a {
  background: #f2f4f6;
}

.site-navbar .site-navigation .site-menu .has-children:hover > a,
.site-navbar .site-navigation .site-menu .has-children:focus > a,
.site-navbar .site-navigation .site-menu .has-children:active > a {
  color: #2d71a1;
}

.site-navbar .site-navigation .site-menu .has-children:hover,
.site-navbar .site-navigation .site-menu .has-children:focus,
.site-navbar .site-navigation .site-menu .has-children:active {
  cursor: pointer;
}

.site-navbar .site-navigation .site-menu .has-children:hover > .dropdown,
.site-navbar .site-navigation .site-menu .has-children:focus > .dropdown,
.site-navbar .site-navigation .site-menu .has-children:active > .dropdown {
  transition-delay: 0s;
  margin-top: -10px;
  visibility: visible;
  opacity: 1;
}

.site-mobile-menu {
  width: 300px;
  position: fixed;
  right: 0;
  z-index: 2000;
  padding-top: 20px;
  background: #fff;
  height: calc(100vh);
  -webkit-transform: translateX(110%);
  transform: translateX(110%);
  box-shadow: -10px 0 20px -10px rgba(0, 0, 0, 0.1);
  transition: .3s all ease-in-out;
}

.offcanvas-menu .site-mobile-menu {
  -webkit-transform: translateX(0%);
  transform: translateX(0%);
}

.site-mobile-menu .site-mobile-menu-header {
  width: 100%;
  float: left;
  padding-left: 20px;
  padding-right: 20px;
}

.site-mobile-menu .site-mobile-menu-header .site-mobile-menu-close {
  float: right;
  margin-top: 8px;
}

.site-mobile-menu .site-mobile-menu-header .site-mobile-menu-close span {
  font-size: 30px;
  display: inline-block;
  padding-left: 10px;
  padding-right: 0px;
  line-height: 1;
  cursor: pointer;
  transition: .3s all ease;
}

.site-mobile-menu .site-mobile-menu-header .site-mobile-menu-logo {
  float: left;
  margin-top: 10px;
  margin-left: 0px;
}

.site-mobile-menu .site-mobile-menu-header .site-mobile-menu-logo a {
  display: inline-block;
  text-transform: uppercase;
}

.site-mobile-menu .site-mobile-menu-header .site-mobile-menu-logo a img {
  max-width: 70px;
}

.site-mobile-menu .site-mobile-menu-header .site-mobile-menu-logo a:hover {
  text-decoration: none;
}

.site-mobile-menu .site-mobile-menu-body {
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  position: relative;
  padding: 0 20px 20px 20px;
  height: calc(100vh - 52px);
  padding-bottom: 150px;
}

.site-mobile-menu .site-nav-wrap {
  padding: 0;
  margin: 0;
  list-style: none;
  position: relative;
}

.site-mobile-menu .site-nav-wrap a {
  padding: 10px 20px;
  display: block;
  position: relative;
}

.site-mobile-menu .site-nav-wrap a:hover {
  color: #2d71a1;
}

.site-mobile-menu .site-nav-wrap li {
  position: relative;
  display: block;
}

.site-mobile-menu .site-nav-wrap li.active > a {
  color: #2d71a1;
}

.site-mobile-menu .site-nav-wrap .arrow-collapse {
  position: absolute;
  right: 0px;
  top: 10px;
  z-index: 20;
  width: 36px;
  height: 36px;
  text-align: center;
  cursor: pointer;
  border-radius: 50%;
}

.site-mobile-menu .site-nav-wrap .arrow-collapse:before {
  font-size: 12px;
  z-index: 20;
  font-family: "icofont";
  content: "\ea99";
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%) rotate(-180deg);
  transform: translate(-50%, -50%) rotate(-180deg);
  transition: .3s all ease;
}

.site-mobile-menu .site-nav-wrap .arrow-collapse.collapsed:before {
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.site-mobile-menu .site-nav-wrap > li {
  display: block;
  position: relative;
  float: left;
  width: 100%;
}

.site-mobile-menu .site-nav-wrap > li > a {
  padding-left: 20px;
  font-size: 20px;
}

.site-mobile-menu .site-nav-wrap > li > ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

.site-mobile-menu .site-nav-wrap > li > ul > li {
  display: block;
}

.site-mobile-menu .site-nav-wrap > li > ul > li > a {
  padding-left: 40px;
  font-size: 16px;
}

.site-mobile-menu .site-nav-wrap > li > ul > li > ul {
  padding: 0;
  margin: 0;
}

.site-mobile-menu .site-nav-wrap > li > ul > li > ul > li {
  display: block;
}

.site-mobile-menu .site-nav-wrap > li > ul > li > ul > li > a {
  font-size: 16px;
  padding-left: 60px;
}

/* Burger */

.burger {
  width: 28px;
  height: 32px;
  cursor: pointer;
  position: relative;
  z-index: 99;
  float: right;
}

.burger:before,
.burger span,
.burger:after {
  width: 100%;
  height: 2px;
  display: block;
  background: #fff;
  border-radius: 2px;
  position: absolute;
  opacity: 1;
}

.burger:before,
.burger:after {
  transition: top 0.35s cubic-bezier(0.23, 1, 0.32, 1), opacity 0.35s cubic-bezier(0.23, 1, 0.32, 1), background-color 1.15s cubic-bezier(0.86, 0, 0.07, 1), -webkit-transform 0.35s cubic-bezier(0.23, 1, 0.32, 1);
  transition: top 0.35s cubic-bezier(0.23, 1, 0.32, 1), transform 0.35s cubic-bezier(0.23, 1, 0.32, 1), opacity 0.35s cubic-bezier(0.23, 1, 0.32, 1), background-color 1.15s cubic-bezier(0.86, 0, 0.07, 1);
  transition: top 0.35s cubic-bezier(0.23, 1, 0.32, 1), transform 0.35s cubic-bezier(0.23, 1, 0.32, 1), opacity 0.35s cubic-bezier(0.23, 1, 0.32, 1), background-color 1.15s cubic-bezier(0.86, 0, 0.07, 1), -webkit-transform 0.35s cubic-bezier(0.23, 1, 0.32, 1);
  -webkit-transition: top 0.35s cubic-bezier(0.23, 1, 0.32, 1), -webkit-transform 0.35s cubic-bezier(0.23, 1, 0.32, 1), opacity 0.35s cubic-bezier(0.23, 1, 0.32, 1), background-color 1.15s cubic-bezier(0.86, 0, 0.07, 1);
  content: "";
}

.burger:before {
  top: 4px;
}

.burger span {
  top: 15px;
}

.burger:after {
  top: 26px;
}

/* Hover */

.burger:hover:before {
  top: 7px;
}

.burger:hover:after {
  top: 23px;
}

/* Click */

.burger.active span {
  opacity: 0;
}

.burger.active:before,
.burger.active:after {
  top: 40%;
}

.burger.active:before {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=5);
  /*for IE*/
}

.burger.active:after {
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=-5);
  /*for IE*/
}

.burger:focus {
  outline: none;
}

/*--------------------------------------------------------------
# Footer
--------------------------------------------------------------*/

.footer {
  padding: 5rem 0 2.5rem 0;
}

.footer h3 {
  font-size: 18px;
  margin-bottom: 30px;
}

.footer ul li {
  margin-bottom: 10px;
}

.footer a {
  color: #000;
}

.footer .copyright {
  margin-bottom: 0px;
}

.footer .copyright,
.footer .credits {
  font-size: 14px;
}

.social a {
  display: inline-block;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #f8f9fa;
  position: relative;
  text-align: center;
  transition: .3s background ease;
  color: #0d1e2d;
}

.social a span {
  display: inline-block;
  left: 50%;
  position: absolute;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.social a:hover {
  color: #fff;
  background: #2d71a1;
}

@media screen and (max-width: 992px) {
  .hero-section .wave {
    bottom: -180px;
  }

  .hero-section.inner-page .hero-text {
    margin-top: -80px;
  }

  .hero-section h1 {
    font-size: 2.5rem;
    text-align: center;
  }

  .hero-section .hero-text-image {
    margin-top: 4rem;
  }

  .hero-section .iphone-wrap {
    text-align: center;
  }

  .hero-section .iphone-wrap .phone-2,
  .hero-section .iphone-wrap .phone-1 {
    position: relative;
    top: 0;
    max-width: 40%;
  }

  .hero-section .iphone-wrap .phone-1 {
    margin-left: -150px;
  }

  .hero-section .iphone-wrap .phone-2 {
    width: 250px;
    position: absolute;
    margin-top: 0px;
    margin-left: 100px;
  }
}

@media (max-width: 768px) {
  .back-to-top {
    bottom: 15px;
  }
}

@media screen and (max-width: 768px) {
  .cta-section h2 {
    font-size: 2rem;
  }
}

.fondo1{
    ul{
        padding: 20px;               
    }
}
.J-chat-form{
		position: relative;
		.J-chat-input{
			height: 35px;
			padding: 10px;
		}
		.J-chat-btn{
			position:  absolute;
			top: 0;
			right: 0;
			width:65px;
			outline: none;
			height: 35px;
			background-color: #007bff;
			color: #fff;
			&:focus{
				box-shadow: none;
			}
		}
	}
.J-container{
    margin-top: 70px;
} 
.menu2{
        width: 40%;
        position: fixed;
        z-index: 100;
        cursor: pointer;
        color:black;
        top:0;
        left:0;
        transition: 0.5s;
        -webkit-transition: all .3s ease-in-out;
        -moz-transition: all .3s ease-in-out;
        -o-transition: all .3s ease-in-out;
        -ms-transition: all .3s ease-in-out;
        transition: all .3s ease-in-out;
        @media screen and (min-width: 300px) {
            width: 32%;
        }
        @media screen and (min-width: 400px) {
            width: 25%;
        }
        @media screen and (min-width: 500px) {
            width: 20%;
        }
        @media screen and (min-width: 600px) {
            width: 20%;
        }
        @media screen and (min-width: 750px) {
            width: 20%;
        }
        @media screen and (min-width: 850px) {
            width: 10%;
        }
        @media screen and (min-width: 1000px) {
            width: 10%;
        }
        @media screen and (min-width: 1100px) {
            width: 10%;
        }
        @media screen and (min-width: 1300px) {
            width: 7%;
        }
    }
  .sidebar-toggle {
    margin-left: -240px;
    }
    .sidebarindex {
    height: 100%;
    width: 100%;
    position: fixed;
    z-index: 200;
    top: 0;
    left: 0;
    overflow: auto;
    background:white;
    padding-top: 10px;
    transition: 0.5s;
    opacity: 0.9;
    -webkit-transition: all .3s ease-in-out;
    -moz-transition: all .3s ease-in-out;
    -o-transition: all .3s ease-in-out;
    -ms-transition: all .3s ease-in-out;
    transition: all .3s ease-in-out;
    z-index: 100;
    transform: translateX(-100%);
        @media screen and (min-width: 300px) {
            width: 75%;
        }
        @media screen and (min-width: 400px) {
            width: 60%;
        }
        @media screen and (min-width: 500px) {
            width: 40%;
        }
        @media screen and (min-width: 600px) {
            width: 40%;
        }
        @media screen and (min-width: 750px) {
            width: 30%;
        }
        @media screen and (min-width: 850px) {
            width: 25%;
        }
        @media screen and (min-width: 1000px) {
            width: 25%;
        }
        @media screen and (min-width: 1100px) {
            width: 20%;
        }
        @media screen and (min-width: 1300px) {
            width: 15%;
        }
        & a {
            padding: 6px 6px 6px 6px;
            text-decoration: none;
            font-size: 1.2em;
            color: black;
            display: block;
            margin: 10px 0;
            transition: all 0.5s;
            &:hover {
                background: rgb(67, 67, 67);
                border-radius: 20px;
                text-align: center;
            }
        }
    #leftside-navigation {
    ul, ul ul {
      margin: -2px 0 0;
      padding: 0;
    }
    ul {
      li {
        list-style-type: none;
        border-bottom: 1px solid rgba(255,255,255,.05);
        &.active {
          & > a {
            color:black;
          }
          ul {
            display: block;
          }
        }
        a {
          color:black;
          text-decoration: none;
          display: block;
          padding: 18px 0 18px 25px;
          font-size: 12px;
          outline: 0;
          -webkit-transition: all 200ms ease-in;
          -moz-transition: all 200ms ease-in;
          -o-transition: all 200ms ease-in;
          -ms-transition: all 200ms ease-in;
          transition: all 200ms ease-in;
          &:hover {
            color:black;
          }
          span {
            display: inline-block;
          }
          i {
            width: 20px;
            .fa-angle-left, .fa-angle-right {
              padding-top: 3px;
            }
          }
        }
      }
    }
    ul ul {
      display: none;
      li {
        background: #23313f;
        margin-bottom: 0;
        margin-left: 0;
        margin-right: 0;
        border-bottom: none;
        a {
          font-size: 12px;
          padding-top: 13px;
          padding-bottom: 13px;
          color: black;
        }
      }
    }
  }
}





</style>


